import { createRoot } from "react-dom/client";
import { SnackbarProvider } from "notistack";
import App from "./App";
import "./language";
import "./theme/styles";
import { AppDataProvider } from "./AppDataContext";

const container = document.getElementById("root") as HTMLElement;

const root = createRoot(container);

root.render(
  <SnackbarProvider maxSnack={5} anchorOrigin={{ horizontal: "right", vertical: "bottom" }}>
    <AppDataProvider>
      <App />
    </AppDataProvider>
  </SnackbarProvider>,
);
